export default __webpack_public_path__ + "static/media/icon-content-esim-24-px.960be954.svg";